import script from "./OrderTrend.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderTrend.vue?vue&type=script&lang=ts&setup=true"

import "./OrderTrend.vue?vue&type=style&index=0&id=0eba0690&lang=scss"

const __exports__ = script;

export default __exports__